import { useEffect } from 'react';
import { useAuth, hasAuthParams  } from 'react-oidc-context';
import { useLocation } from 'react-router';
import { useIdleTimeout } from './IdleTimeout';
function ProtectedRoute({ children }) {

    const auth = useAuth();
    const location = useLocation();
 
    // Track that the user has been authenticated in this browser session
    useEffect(() => {
      if (auth.isAuthenticated) {
        sessionStorage.setItem('was_authenticated', 'true');
      }
    }, [auth.isAuthenticated]);

    // Handle back-button from logged_out page (bfcache restore) — treat as first-time visitor
    useEffect(() => {
      const handlePageShow = (e) => {
        if (e.persisted && !auth.isAuthenticated) {
          sessionStorage.removeItem('was_authenticated');
          window.location.reload();
        }
      };
      window.addEventListener('pageshow', handlePageShow);
      return () => window.removeEventListener('pageshow', handlePageShow);
    }, [auth.isAuthenticated]);

     useIdleTimeout(() => {
      if (auth.isAuthenticated) {
        const id_token = auth.user?.id_token;
        auth.removeUser();
        auth.signoutRedirect({ id_token_hint: id_token });
      }
    });
    // automatically sign-in
    useEffect(() => {
      if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading) {
        
        sessionStorage.setItem('auth_return_url', location.pathname + location.search);
        auth.signinRedirect();
      }
    }, [auth, auth.isAuthenticated, auth.activeNavigator, auth.isLoading, auth.signinRedirect, location.pathname, location.search]);
    
    useEffect(() => {
      const callback = () => {
        sessionStorage.setItem('auth_return_url', location.pathname + location.search);
        auth.signinRedirect();
      }
      return auth.events.addAccessTokenExpired(callback);
    }, [auth, location.pathname, location.search]);

    if (auth.activeNavigator === "signinSilent")
        return <div>Signing you in...</div>;
    else if (auth.activeNavigator === "signoutRedirect") {
        // If signout completed but navigator is stale (back button), trigger sign-in
        if (!auth.isAuthenticated && !auth.isLoading) {
          sessionStorage.removeItem('was_authenticated');
          auth.signinRedirect();
          return <div>Signing you in...</div>;
        }
        return <div>Signing you out...</div>;
    }
    else if (auth.isLoading)
      return <div>Loading...</div>;
    else if (auth.error) 
      return <div>Oops... {auth.error.message}</div>;
    else if (!auth.isAuthenticated)
      return <div>Not logged in</div>;

    return children;
}

export default ProtectedRoute;